import React, { Component } from "react";
import axios from "axios";
import {
  API_INFORMES,
  API_INFORMES_PDF,
  TIPO_INFORME_EVAL_PLAN,
  RAMA_SENSORIAL,
  pdfEvalPlanScript,
  emptyDatosEvalPlanSensorial,
  estadoFirmaEspecialista,
  MSG_FIRMA_PDF_REQUERIDA,
} from "./api";
import FirmaEspecialistaInforme from "./FirmaEspecialistaInforme";
import { TIPO_CAMPO, CAMPOS_DATOS_GENERALES, CAMPOS_SECCIONES } from "./camposEvalPlanSensorial";

class InformeEvaluacionPlanSensorial extends Component {
  constructor(props) {
    super(props);
    this.firmaRef = React.createRef();
    this.state = {
      datos: emptyDatosEvalPlanSensorial(),
      guardando: false,
      tieneFirmaEsp: false,
    };
  }

  componentDidMount() {
    this.cargarDatos();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.idInforme !== this.props.idInforme ||
      prevProps.idasociarE !== this.props.idasociarE ||
      prevProps.initialDatos !== this.props.initialDatos
    ) {
      this.cargarDatos();
    }
  }

  cargarDatos = () => {
    if (this.props.initialDatos && !this.props.idInforme) {
      this.setState({
        datos: {
          ...emptyDatosEvalPlanSensorial(),
          ...this.props.initialDatos,
          datosGenerales: {
            ...emptyDatosEvalPlanSensorial().datosGenerales,
            ...(this.props.initialDatos.datosGenerales || {}),
          },
        },
      });
      return;
    }
    const { idInforme, cedulaPaciente, idasociarE } = this.props;
    if (idInforme > 0) {
      const data = new FormData();
      data.append("boton", "obtener");
      data.append("idInforme", idInforme);
      data.append("cedulaEspecialista", this.props.cedulaEspecialista || "");
      axios.post(API_INFORMES, data).then((res) => {
        if (res.data.variable1) {
          this.setState({
            datos: res.data.variable3 || emptyDatosEvalPlanSensorial(),
          });
        }
      });
      return;
    }
    const data = new FormData();
    data.append("boton", "datosPacienteBase");
    data.append("cedulaPaciente", cedulaPaciente);
    data.append("idasociarE", idasociarE);
    data.append("tipoInforme", TIPO_INFORME_EVAL_PLAN);
    data.append("ramaEspecialidad", RAMA_SENSORIAL);
    axios.post(API_INFORMES, data).then((res) => {
      if (res.data.variable1) {
        const base = res.data.variable2;
        this.setState({
          datos: {
            ...emptyDatosEvalPlanSensorial(),
            datosGenerales: {
              ...emptyDatosEvalPlanSensorial().datosGenerales,
              nombreApellido: base.nombreApellido || "",
              fnacimiento: base.fnacimiento || "",
              edadTexto: base.edadTexto || base.edad || "",
              centroEducativo: base.colegio || base.escuela || "",
              diagnostico: base.diagnostico || "",
              nombreTerapeuta: this.props.nombreEspecialista || "",
              fechaEvaluacion: base.fechaInforme || "",
              fechaInforme: base.fechaInforme || "",
            },
          },
        });
      }
    });
  };

  setDg = (field, value) => {
    this.setState({
      datos: {
        ...this.state.datos,
        datosGenerales: { ...this.state.datos.datosGenerales, [field]: value },
      },
    });
  };

  setField = (field, value) => {
    this.setState({ datos: { ...this.state.datos, [field]: value } });
  };

  guardar = () => {
    const {
      cedulaPaciente,
      cedulaEspecialista,
      tipoEvaluacion,
      idasociarE,
      idasociarEGrupo,
      sede,
      idInforme,
      onGuardado,
    } = this.props;
    const { datos } = this.state;
    const dg = datos.datosGenerales;
    this.setState({ guardando: true });
    const data = new FormData();
    data.append("boton", "guardar");
    data.append("tipoInforme", TIPO_INFORME_EVAL_PLAN);
    data.append("ramaEspecialidad", RAMA_SENSORIAL);
    data.append("idInforme", idInforme || 0);
    data.append("cedulaPaciente", cedulaPaciente);
    data.append("cedulaEspecialista", cedulaEspecialista);
    data.append("tipoEvaluacion", tipoEvaluacion);
    data.append("idasociarE", idasociarE);
    const idsGrupo =
      Array.isArray(idasociarEGrupo) && idasociarEGrupo.length > 0
        ? idasociarEGrupo
        : [idasociarE];
    data.append("idasociarEGrupo", idsGrupo.join(","));
    data.append("formato", "SENSORIAL");
    data.append("fechaInforme", dg.fechaInforme);
    data.append("fechaInicioTerapia", dg.fechaEvaluacion || dg.fechaInforme || "");
    data.append("sede", sede || "");
    data.append("usuario", cedulaEspecialista);
    data.append("datosJson", JSON.stringify(datos));
    axios.post(API_INFORMES, data).then((res) => {
      this.setState({ guardando: false });
      if (res.data.variable1) {
        alert("Fue guardado el Informe de Evaluación y Plan");
        if (onGuardado) onGuardado(res.data.variable2);
      } else {
        alert(res.data.variable2 || res.data.variable3 || "Error al guardar.");
      }
    });
  };

  imprimir = async () => {
    const { idInforme, cedulaEspecialista } = this.props;
    const { tieneFirmaEsp } = this.state;
    if (!idInforme) {
      alert("Guarde el informe antes de imprimir.");
      return;
    }
    let tieneFirma = tieneFirmaEsp;
    if (!tieneFirma) {
      try {
        const est = await estadoFirmaEspecialista(cedulaEspecialista);
        tieneFirma = est.tiene;
        if (tieneFirma) this.setState({ tieneFirmaEsp: true });
      } catch (e) {
        tieneFirma = false;
      }
    }
    if (!tieneFirma) {
      alert(MSG_FIRMA_PDF_REQUERIDA);
      if (this.firmaRef.current && this.firmaRef.current.abrirSelector) {
        this.firmaRef.current.abrirSelector();
      }
      return;
    }
    const script = pdfEvalPlanScript("SENSORIAL", RAMA_SENSORIAL);
    const data = new FormData();
    data.append("idInforme", idInforme);
    axios({
      method: "post",
      url: API_INFORMES_PDF + script,
      responseType: "arraybuffer",
      data,
    })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        window.open(URL.createObjectURL(blob));
      })
      .catch(() => {
        window.open(API_INFORMES_PDF + script + "?idInforme=" + idInforme, "_blank");
      });
  };

  renderControl = (config, value, onChange) => {
    const tipo = config.tipo || TIPO_CAMPO.MULTILINEA;
    if (tipo === TIPO_CAMPO.FECHA) {
      return (
        <input
          type="date"
          className="ic-input ic-input-line"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );
    }
    if (tipo === TIPO_CAMPO.MULTILINEA || !config.tipo) {
      return (
        <textarea
          className="ic-textarea"
          rows={config.rows || 4}
          maxLength={config.maxLength || 4000}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );
    }
    return (
      <input
        type="text"
        className="ic-input ic-input-line"
        maxLength={config.maxLength || 120}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  };

  renderSeccion = (titulo, children) => (
    <div className="ic-formSection">
      <h4>{titulo}</h4>
      {children}
    </div>
  );

  render() {
    const { guardando } = this.state;
    return (
      <div className="ic-panel ic-form-document">
        <p>
          Paciente:{" "}
          <strong>{this.props.nombrePaciente || this.props.cedulaPaciente}</strong>
        </p>
        <p className="ic-formato-badge">
          <strong>Informe de Evaluación y Plan — Integración Sensorial</strong>
        </p>
        <div className="ic-actions ic-actions-sticky">
          <button type="button" className="boton" onClick={this.props.onVolver}>
            Volver
          </button>
        </div>

        {this.renderSeccion(
          "Datos generales",
          <div className="ic-grid-datos">
            {CAMPOS_DATOS_GENERALES.map((c) => (
              <div className="ic-field" key={c.key}>
                <label className="ic-label">{c.label}</label>
                {this.renderControl(c, this.state.datos.datosGenerales[c.key], (v) =>
                  this.setDg(c.key, v)
                )}
              </div>
            ))}
          </div>
        )}

        {CAMPOS_SECCIONES.map((c) =>
          this.renderSeccion(
            c.label,
            <div className="ic-field" key={c.key}>
              {this.renderControl(c, this.state.datos[c.key], (v) => this.setField(c.key, v))}
            </div>
          )
        )}

        <FirmaEspecialistaInforme
          ref={this.firmaRef}
          cedulaEspecialista={this.props.cedulaEspecialista}
          onCambio={(tiene) => this.setState({ tieneFirmaEsp: tiene })}
        />

        <div className="ic-actions">
          <button type="button" className="boton" onClick={this.guardar} disabled={guardando}>
            {guardando ? "Guardando..." : "Guardar"}
          </button>
          <button type="button" className="boton" onClick={this.imprimir}>
            Imprimir PDF
          </button>
          {this.props.idInforme > 0 && this.props.onEliminar && (
            <button
              type="button"
              className="boton ic-btn-danger"
              onClick={() => this.props.onEliminar(this.props.idInforme)}
            >
              Eliminar informe
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default InformeEvaluacionPlanSensorial;
